import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import TimeLineItemAtividade from "./TimeLineItemAtividade.jsx";

class TimeLineItemAtividadeContainer extends React.Component {
  constructor(props) {
    super(props);

    this.atividadeIdParaExcluir = 0;
    this.state = { modalExcluirOpen: false };
    this.reload = this.reload.bind(this);
  }

  callback = success => {
    if (success) this.reload();
  };

  reload() {
    document.dispatchEvent(new Event("detalhe-lead/timeline/reload"));
  }

  handleOpenModalExcluirAtividade = atividadeId => {
    this.atividadeIdParaExcluir = atividadeId;
    this.setState({ modalExcluirOpen: true });
  };

  handleCloseExcluirAtividade = () => {
    this.setState({ modalExcluirOpen: false });
  };

  handleConcluirAtividade = () => {
    const { atividade, lead } = this.props;
    this.props.handleConcluirAtividade({ ...atividade, lead });
  };

  handleEditarAtividade = () => {
    const { atividade } = this.props;
    this.props.handleEditarAtividade(atividade.atividadeId);
  };

  render() {
    return (
      <TimeLineItemAtividade
        atividade={this.props.atividade}
        handleAbrirModalAtividadeEditar={this.handleAbrirModalAtividadeEditar}
        handleOpenModalExcluirAtividade={this.handleOpenModalExcluirAtividade}
        modalExcluirOpen={this.state.modalExcluirOpen}
        usuarioLogado={this.props.usuarioLogado}
        callback={this.callback}
        handleConcluirAtividade={this.handleConcluirAtividade}
        handleEditarAtividade={this.handleEditarAtividade}
        isTimelineAtividades={this.props.isTimelineAtividades}
      />
    );
  }
}

TimeLineItemAtividadeContainer.propTypes = {
  lead: PropTypes.object,
  atividade: PropTypes.object,
  usuarioLogado: PropTypes.object,
  handleConcluirAtividade: PropTypes.func,
  handleEditarAtividade: PropTypes.func,
  isTimelineAtividades: PropTypes.bool,
};

const mapStateToProps = state => ({
  usuarioLogado: state.usuario,
});

export default connect(mapStateToProps)(TimeLineItemAtividadeContainer);
